import { any } from "@amcharts/amcharts4/.internal/core/utils/Array";
import { coerceNumberProperty } from "@angular/cdk/coercion";
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";
import { SelectItem } from "primeng/api";
import { AssignActionForSourcePost } from "../../../actiontracker/model/actionDetails.model";
import { CheckListItem } from "../../../masterscreen/model/permission-list-model";
import { MasterscreenService } from "../../../masterscreen/services/masterscreen.service";
import { ActionListForHSEAdvisor } from "../../../observation/components/raise-observation/raise-observation.component";
import { Login } from "../../../observation/model/login.model";
import { SearchText } from "../../../observation/model/searchTexts.model";
import { Usertypes } from "../../../observation/model/usertypes.model";
import { ObservationConstantsService } from "../../../observation/services/observation-constants.service";
import { ObservationService } from "../../../observation/services/observation.service";
import { SpecificationData } from "../../../shared/components/category/category.component";
import {
  UserLogInActivity, UserLogInActivityDetails,
  User,
  UserPermissionParameters
} from "../../../shared/models/user.model";
import { BaseService } from "../../../shared/services/base.service";
import { CommonService } from "../../../shared/services/common.service";
import { ConstantsService } from "../../../shared/services/constants.service";
import { NotificationsService } from "../../../shared/services/notification.service";
import { FileUtility } from "../../../shared/utility/file.utility";
import { InspectionPermission } from "../../model/inspectionPermission.model";
import { InspectionConstantsService } from "../../Services/inspection-constants.service";
import { InspectionService } from "../../Services/inspection.service";

@Component({
  selector: "ara-raise-inspection",
  templateUrl: "./raise-inspection.component.html",
  styleUrls: ["./raise-inspection.component.css"]
})
export class RaiseInspectionComponent implements OnInit {
  routesFlag: { routeName: string; routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string; routeURL: string; isClickable: boolean; }[];
  inspectionRequest: InspectionRequest;
  login: Login;
  // observationService: any;
  locations: SelectItem[];
  loggedInUserJSON: any;
  checkListDetails: any;
  inspectionCheckLists: SelectItem[];
  selectedLocation: number;
  selectedContractId: number;
  hseErrorHandler: any;
  user: User;
  userTypes: Usertypes[] = [];
  searchTexts: SearchText;
  userResults: User[] = [];
  selectedContractor: User;
  selectedInspector: User;
  allInspectorsResults: any;
  allInspectorsData:SelectItem[]= [];
  selectedInspectors: any[] = [];
  displaySelectedInspectorsNames: any[] = [];
  IsJobStopped: string;
  checklistPoints: CheckListItem[]= [];
  accept: string;
  checklistPointDescr: { Id: number; Value: string }[];
  sub: any;
  inspectionId: number = 0;
  alertType: any;
  successDetails: string;
  inspectionrefId: any;
  validate: boolean;
  isContractorNameErrorMsg: boolean;
  isInspectorNameErrorMsg: boolean;
  isLocationErrorMsg: boolean;
  isInspectionNameErrorMsg: boolean;
  isInspectionDescriptionErrorMsg: boolean;
  isRemarksErrorMsg: boolean;
  isInspectorIdsMsg: boolean;
  multiple: boolean;
  tempFiles: any[];
  disableUpload: boolean = false;
  instructionDocuments: any[] = [];
  selectedIndex: any;
  inspectionDocument: boolean;
  uploadedDocument: boolean;
  uploadedDocuments: any[] = [];
  dateTime: Date;
  actionList: AssignActionForSourcePost[];
  inspectionActions: ActionListForHSEAdvisor;
  selectedUnit: any;
  unitTree: any;
  isNext: boolean = true;
  isPrevious: boolean = true;
  isUpdateAllowed: boolean = false;
  inspectionIds: any;
  inspectionIndex: number = -1;
  unitList: any;
  permissions: InspectionPermission = new InspectionPermission();
  disableInspection: boolean = false;
  moduleId: number;
  categoryData: any;
  specificationDetailsData: any;
  independentPermissions: any;
  cancelRecord: boolean;
  cancelActionId: any;
  cancellationReason: any;
  deleteRecord: boolean;
  deleteActionId: any;
  deletionReason: any;
  incidentLoaded: boolean;
  calledForExisting: boolean = false;
  isActive: boolean = false;
  //BOC Pritesh
  dialogHeight: string;
  dialogWidth: string;
  ReportUserId : number;
  ReportModule : string;
  ReportRecordId : number;
  ReportProcessId : number = 0;
  ReportclosePopup: boolean = false;
  updateinspectionData:any;
  retVal:boolean;
  userLogInActivityDetails: UserLogInActivityDetails;
  userActivityList: UserLogInActivity[];
  CheckListValue:any;
  isInactiveLocation: boolean = false;

  unitError : boolean;
  //EOC Pritesh
  editEnabled: boolean = true;
  IsNewRecord:boolean = true;
  contracts: { label: string; value: string }[] = [];
  unitContractDetails: any[] = [];
  isHasContractDetails: boolean = true;
  isContractErrorMsg: boolean = true;
  isEmployeeUnit:boolean=true;
  isContractHolder: boolean = false;
  showDeletionmsg: boolean=false;
  showCancellationmsg: boolean=false;

  constructor(
    private route: ActivatedRoute,
    private ref: ChangeDetectorRef,
    private router: Router,
    private inspectionService: InspectionService,
    private observationService: ObservationService,
    private baseService: BaseService,
    private masterscreenService: MasterscreenService,
    private notificationsService: NotificationsService,
    private commonService: CommonService,
    private translate: TranslateService
  ) {
    this.inspectionRequest = new InspectionRequest();
    this.searchTexts = new SearchText();
    this.specificationDetailsData = new SpecificationData();
    this.moduleId = ConstantsService.PermissionMatrixModules.Inspection;
    this.userActivityList = [];
  }
  
  
  ngOnInit() {
   
    this.baseService.showRootLoader = true;
    let routes = JSON.stringify(
      InspectionConstantsService.InspectionNavigation.Routes
    );
    this.routesFlag = JSON.parse(routes);
    this.reportRoutes = InspectionConstantsService.InspectionNavigation.ReportRoutes;
    const loggedInUser = this.baseService.getItemFromSession("loggedInUser");
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    this.login = new Login();
    this.login.CompanyId = this.loggedInUserJSON.Company.CompanyId;
    this.login.ID = this.loggedInUserJSON.UserId;
    this.sub = this.route.params.subscribe((params) => {
      this.inspectionId = coerceNumberProperty(params["InspectionRequestId"]);
      this.inspectionrefId = this.inspectionId;
      this.selectedContractor = new User();
      this.selectedInspector = new User();
      this.selectedInspectors= [];
      this.displaySelectedInspectorsNames=[];
      if (this.inspectionId !== 0 && this.inspectionId) {
      
        this.IsNewRecord = false;

      }
    });
      
    
    this.selectedLocation = this.baseService.getItemFromSession(
      "Location" + this.loggedInUserJSON.Company.CompanyName
    );
    this.baseService.showRootLoader = true;
    this.masterscreenService.getCheckListNames(
      null,
      this.callbackMethodForGetCheckLists.bind(this)
    );
    this.accept =
      ".jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.pdf,.PDF,.docx,.DOCX,.xlsx,.XLSX,.doc,.DOC,.pptx,.PPTX,.ppt,.PPT,.heic,.HEIC,.heif,.HEIF";
    this.IsJobStopped = "false";
    this.checklistPointDescr =
      InspectionConstantsService.CheckLitPoints.Description;
    this.multiple = true;
    this.disableUpload = false;
    this.actionList = [];
    this.actionList.push(new AssignActionForSourcePost());
    this.inspectionActions = new ActionListForHSEAdvisor();
    this.independentPermissions = JSON.parse(
      this.baseService.getItemFromSession("UserIndependentPermissions")
    );
    if (
      !this.independentPermissions.INSP_Add &&
      !this.independentPermissions.INSP_Add_Unit &&
      !this.independentPermissions.INSP_Admin &&
      !this.independentPermissions.INSP_Admin_Unit
    ) {
      this.routesFlag.find(s => s.routeName == "Add Inspection").isClickable = false;
    }
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });
    this.disableInspection = false;
  }
  callbackMethodForUnitDetails(response) {
    if (response.Result) {
      this.unitList = response.Result;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          GetActiveNodes: this.IsNewRecord,
          UserId: this.loggedInUserJSON.UserId
        }
      };
      this.masterscreenService.getTreeData(
        apiRequest,
        this.callbackMethodForGetTreeData.bind(this)
      );
    }
    this.baseService.showRootLoader = false;
  }
  callbackMethodForGetTreeData(response) {
    if (response.Result !== null) {
      this.unitTree = response.Result;
      this.getUserTypes();
      this.setInpectorsUsersData();
      if (this.inspectionId === 0) {
        this.unitTree.forEach((element) => {
          this.compareTreeNode(element, 0);
        });
        this.getPermissions(0);
        if (!this.selectedInspectors.length) {
          this.selectedInspectors.push(this.loggedInUserJSON.UserId);
          this.changeValueofInspector();
        }
      } else {
        this.getinspectionDataByInspectionId();
      }
    }
    this.baseService.showRootLoader = false;
  }
  nodeSelected(event) {
    this.selectedUnit = event.node;
    if (this.selectedUnit.children && this.selectedUnit.children.length > 0) {
      this.selectedUnit.expanded = true;
    }
    this.getLocation();
    this.getPermissions(this.selectedUnit.UnitId);
    this.getIsActiveUnit(this.selectedUnit.UnitId);
    this.isEmployeeUnit=true;
    if(event.node.UnitTypeId == 2)
    {
      this.isEmployeeUnit=false;
      this.getContractDetails(this.selectedUnit.UnitId);
    }
  }
  getContractDetails(unitId: number): void {
    const apiRequestUnit = {
      Model: {
        "UnitId": unitId
      },
    };
    this.masterscreenService.getContractDetailsData(
      apiRequestUnit,
      this.callbackMethodForContractDetails.bind(this)
    );
  }
  callbackMethodForContractDetails(response) {
     
    this.contracts = [];
    this.unitContractDetails = response;
    let contractHolderId;
    response.forEach(contract => {
      this.contracts.push({ label: contract.ContractNumber, value: contract.UnitContractDetailsId });
      
    });
    if (this.inspectionId !== 0 && this.inspectionId && this.contracts.some(c => c.value == this.inspectionRequest.ContractId.toString())) {
      let currentContract = this.contracts.find(c => c.value.toString() === this.inspectionRequest.ContractId.toString());
    
      this.isContractErrorMsg=false;
      this.checkHolder(currentContract);
      this.isContractHolder=false;
      if(currentContract!=null)
      {
      contractHolderId = response.find(h => h.UnitContractDetailsId.toString() === this.inspectionRequest.ContractId.toString()).ContractHolderId
      this.isContractHolder = contractHolderId === this.loggedInUserJSON.UserId ? true : false;
      }
    }
    else 
    {
      this.isContractErrorMsg=true;
    }
  }
  getIsActiveUnit(unitId) {
 
    const apiRequestUnit = {
      Model: {
        UnitId: unitId,  
      },
    };
    this.masterscreenService.getIsActiveUnit(
      apiRequestUnit,
      this.callbackMethodForgetIsActiveUnit.bind(this)
    );
  }

  callbackMethodForgetIsActiveUnit(response) {

    this.editEnabled = response.Result[0].IsActive;
   
    
  }
  checkHolder(event) {
    this.selectedContractId=0;
    let contract;
    contract = this.unitContractDetails.find(contract => contract.UnitContractDetailsId === event.value);
    if (contract.ContractHolderId && contract.ContractNumber != '') {
      this.isContractErrorMsg=false;
      this.isHasContractDetails = true;
      this.selectedContractId=event.value;
    } 
    else {
      this.isContractErrorMsg=true;
      this.isHasContractDetails = false;
    }
  }

  getinspectionDataByInspectionId() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        InspectionRequestId: this.inspectionId
      }
    };
    this.inspectionService.getInspectionDataByInspectionRequestId(
      apiRequest,
      this.callbackMethodForgetInspectionRequest.bind(this)
    );
  }
  compareTreeNode(node, selectedNode) {
    var isFound: boolean = false;
    this.unitList.forEach((element) => {
      if (element.UnitId === node.UnitId) {
        isFound = true;
      }
    });
    if (!isFound || !node.IsActive) {
      node.selectable = false;
      node.expanded = false;
    }
    if (node.ParentId !== 0) {
      node.expanded = false;
    }
    if (node.UnitId === selectedNode) {
      this.selectedUnit = node;
      this.expandParents(this.selectedUnit);
    }
    if (node.children && node.children.length > 0) {
      node.selectable = false;
      node.children.forEach((element) => {
        var isFound: boolean = false;
        this.unitList.forEach((unit) => {
          if (unit.UnitId === element.UnitId) {
            isFound = true;
          }
        });
        if (!isFound || !element.IsActive) {
          element.selectable = false;
          element.expanded = false;
        }
        if (element.ParentId !== 0) {
          element.expanded = false;
        }
        if (element.UnitId === selectedNode) {
          this.selectedUnit = element;
          this.expandParents(this.selectedUnit);
        }
        if (element.children && element.children.length > 0) {
          this.compareTreeNode(element, selectedNode);
        }
      });
    }
  }
  expandParents(node) {
    if (node.parent) {
      node.parent.expanded = true;
      this.expandParents(node.parent);
    }
  }
  callbackMethodForgetInspectionRequest(response) {
    if (response && response.Success) {
      // if (this.loggedInUserJSON.UserTypes.UserType ===
      //   ObservationConstantsService.RequestFor.Contractor && response.Result.CreatedBy != this.loggedInUserJSON.UserId
      // ) {
      //   this.notificationsService.toastNotify(
      //     "error",
      //     "Warning Message",
      //     "This Inspection not raised by you, you don't have permission to view this record...!"
      //   );   
      //   this.router.navigate([
      //     InspectionConstantsService.RoutingURLConstant.InspectionOverviewURL,
      //   ]);
      //   return ; 
      // }
      this.inspectionRequest = response.Result;
      //BOC Pritesh
      this.inspectionService.setUpdatedInspectionData(
        JSON.stringify(this.inspectionRequest)
        );

        this.inspectionService.setoldActionData(
          JSON.stringify(this.inspectionRequest.ActionDetails)
          );  
      //EOC Pritesh   
      this.isActive = this.inspectionId > 0 ? false : true;
     // this.IsNewRecord = this.inspectionId > 0 ? false : true;
      this.incidentLoaded = true;
      this.unitTree.forEach((element) => {
        this.compareTreeNode(element, this.inspectionRequest.UnitId);
      });
      
      this.isEmployeeUnit=true;
    if(this.selectedUnit.UnitTypeId == 2)
    {
      this.isEmployeeUnit=false;
      this.getContractDetails(this.selectedUnit.UnitId);
     
    }
      this.getPermissions(this.inspectionRequest.UnitId);
      this.getLocation();
      this.calledForExisting = true;
      if (this.inspectionRequest.ActionDetails!=null && this.inspectionRequest.ActionDetails.length > 0) {
        this.actionList = this.inspectionRequest.ActionDetails;
        this.actionList.forEach((element) => {
          element.TargetDate = moment(
            moment.utc(element.TargetDate).local()
          ).toDate();
          this.ref.detectChanges();
          element.FilesPreview = element.Files;
          element.Files = element.Files;
        });
      } else {
        this.actionList = [];
        this.actionList.push(new AssignActionForSourcePost());
      }
      this.selectedContractId=this.inspectionRequest.ContractId;
      this.selectedLocation = this.inspectionRequest.LocationId;
      this.checklistPoints = response.Result.CheckListItems;
      this.IsJobStopped = this.inspectionRequest.IsJobStopped.toString();
      this.selectedContractor = response.Result.Contractor;
      this.selectedInspector = response.Result.Inspector; 
      this.selectedInspectors = response.Result.InspectorIds;
      this.changeValueofInspector();
      
      this.inspectionRequest.InspectionDate = new Date(
        moment(
          moment.utc(this.inspectionRequest.InspectionDate).local()
        ).format("MMM D, YYYY LT")
      );
      this.uploadedDocuments = [];
      if (this.inspectionRequest.InspectionFiles !== null) {
        this.uploadedDocuments = this.inspectionRequest.InspectionFiles;
      }
      if (this.inspectionRequest.CheckListFiles !== null) {
      this.instructionDocuments = this.inspectionRequest.CheckListFiles;
      this.inspectionRequest.InspectionInstruction = this.inspectionRequest.CheckListFiles;
      }
      if (
        this.inspectionRequest.Status === "Cancelled" ||
        this.inspectionRequest.Status === "Deleted"
      ) {
        this.disableInspection = true;
      }
      
      this.inspectionIds = this.inspectionService.getAllInspectionIds();
      if(this.inspectionIds == null){
        this.isNext = false;
        this.isPrevious = false;
      }
      let currentIndex: number = 0;
      if(this.inspectionIds!=null)
      {
      this.inspectionIds.forEach((element, index) => {
        if (element.InspectionId === this.inspectionId) {
          currentIndex = index;
          return;
        }
      });
    }
      if (currentIndex === 0) {
        this.isPrevious = false;
      }
      if (currentIndex === this.inspectionIds.length - 1) {
        this.isNext = false;
      }
    }
    this.baseService.showRootLoader = false;
  }
  getUserTypes() {
    this.baseService.showRootLoader = true;
    this.observationService.getUserTypes(
      this.callbackMethodForgetUserTypes.bind(this)
    );
  }
  callbackMethodForgetUserTypes(response) {
    if (response.Error != null) {
      this.hseErrorHandler.handleError(response.Error);
    }

    if (response.Success) {
      this.userTypes = response.Result;
    }
    this.baseService.showRootLoader = false;
  }
  callbackMethodForGetCheckLists(response) {
    if (response.Success) {
      this.inspectionCheckLists = [];
      this.checkListDetails = response.Result;
      this.checkListDetails.forEach((check) => {
        this.inspectionCheckLists.push({
          label: check.CheckListName,
          value: check.CheckListId
        });
      });
      this.baseService.showRootLoader = true;
      const apiRequestUnit = {
        Model: {
          ModuleId: ConstantsService.PermissionMatrixModules.Inspection,
          UserId: this.loggedInUserJSON.UserId,
          IsActive : this.IsNewRecord
        }
      };
      this.masterscreenService.getUnits(
        apiRequestUnit,
        this.callbackMethodForUnitDetails.bind(this)
      );      
    }
    this.baseService.showRootLoader = false;
  }
  getLocation() {
    this.baseService.showRootLoader = true;
    if (this.login) {
      this.login.UnitId = this.selectedUnit.UnitId;
      const apiRequest = {
        Model: {
          ...this.login,
          GetActiveLocations: this.inspectionId == 0 ? true : false,
        }
      };
      // Call dummy method to post data
      this.observationService.getLocationData(
        apiRequest,
        this.callbackMethodForGetLocationData.bind(this)
      );
    }
  }
  saveLocation() {
    this.baseService.setItemInSession(
      "Location" + this.loggedInUserJSON.Company.CompanyName,
      this.selectedLocation
    );
    this.locations.forEach((location) => {
      if (location.value === this.selectedLocation) {
        this.inspectionRequest.LocationId = location.value;
        this.isInactiveLocation = (location?.InActive === true)? true:false;
      }
    });
  }
  // call back method of get location
  callbackMethodForGetLocationData(response) {
    if (response === undefined) {
      // this.serviceError();
    }
    if (response.Success) {
      this.locations = [];
      const locationDetails = response.Result;
      locationDetails.forEach((location) => {
        this.locations.push({
          label: location.LocationName,
          value: location.LocationId,
          InActive :location?.InActive
        });
        
        if (location.LocationId === this.selectedLocation) {
          this.inspectionRequest.LocationId = location.LocationId;
           this.isInactiveLocation = (location?.InActive === true)? true:false;
        }
      });
    }
    this.baseService.showRootLoader = false;
  }
  getUsersOnSearch(event) {
    // this.userTypes.forEach(userType => {
    //   if (userType.UserType === 'Employee') {
    //     this.searchTexts.UserTypeId = userType.UserTypeId;
    //   }
    // });
    if (this.loggedInUserJSON) {
      if (typeof event === "string" || event instanceof String) {
        this.searchTexts.FilterTexts = "";
      } else {
        this.searchTexts.FilterTexts = event.query;
      }
      this.searchTexts.CompanyId = 0;
      this.searchTexts.UserTypeId = 0;
      this.searchTexts.UnitId = this.selectedUnit.UnitId;
      const apiRequest = {
        Model: this.searchTexts
      };
      this.observationService.getSearchResultsForUsers(
        apiRequest,
        this.callbackMethodForGetSearchResultsForUsersData.bind(this)
      );
    }
  }
  callbackMethodForGetSearchResultsForUsersData(response) {
    if (response === undefined) {
      // this.serviceError();
    }

    if (response.Success) {
      const filtered: any[] = [];
      for (let i = 0; i < response.Result.length; i++) {
        this.user = response.Result[i];
        if (
          this.user.FullName.toLowerCase().indexOf(
            this.searchTexts.FilterTexts.toLowerCase()
          ) !== -1
        ) {
          filtered.push(this.user);
        }
      }
      this.userResults = filtered;
    }

    if (response.Errors !== null) {
      this.hseErrorHandler.handleError(response.Errors);
    }
  }
  setCheckListPoint(event) {
    
    this.getCheckListDetails(event.value);
    this.inspectionRequest.CheckListId = event.value;
    this.inspectionRequest.InspectionName = event.originalEvent.target.innerText;
  }
  changeValue($event, checklist, check) {
    this.inspectionRequest.CheckListItems = this.checklistPoints;
  }
  submitInspectionDetails() {
 
    this.baseService.showRootLoader = true;
    this.inspectionRequest.ContractorId = this.selectedContractor.UserId;
    this.inspectionRequest.ContractId  = this.isEmployeeUnit?0: this.selectedContractId;
    if (this.inspectionId === 0) {
      this.inspectionRequest.InspectorId = this.loggedInUserJSON.UserId;      
    } else {
      this.inspectionRequest.InspectorId = this.selectedInspector.UserId;
      if (this.categoryData && this.categoryData.length > 0) {
        this.submitSpecificationData();
      }
    }
    this.inspectionRequest.InspectorIds =this.selectedInspectors;
    this.inspectionRequest.CreatedBy = this.loggedInUserJSON.UserId;
    this.inspectionRequest.ModifiedBy = this.loggedInUserJSON.UserId;
    this.inspectionRequest.CheckListItems = this.checklistPoints;
    this.inspectionRequest.UnitId = this.selectedUnit.UnitId;
    this.inspectionRequest.IsDraft = false;
    if (this.IsJobStopped === "true") {
      this.inspectionRequest.IsJobStopped = true;
    } else {
      this.inspectionRequest.IsJobStopped = false;
    }
    const apiRequest = {
      Model: this.inspectionRequest
    };
    // Call dummy method to post data
    this.inspectionService.saveInspection(
      apiRequest,
      this.callbackMethodForsaveInspection.bind(this)
    );
  }
  callbackMethodForsaveInspection(response) {
    if (response.Success) {
      this.inspectionrefId = response.Result;
      if (this.actionList && this.actionList.length >= 1) {
        this.updateAction();
      }
      //this.alertType = ConstantsService.Success;
      if (this.inspectionId > 0) {
        //BOC Pritesh
          this.updateinspectionData = JSON.parse(
            this.inspectionService.getUpdatedInspectionData()
          );
          this.trackDetails(
            this.updateinspectionData,
            this.inspectionRequest,
            "UpdateAction",
            false
          );
        //EOC Pritesh
        this.notificationsService.toastNotify(
          "success",
          "Success Message",
          "Inspection Updated Successfully"
        );
        //this.successDetails = 'Inspection Updated Successfully';
      } else {
        this.notificationsService.toastNotify(
          "success",
          "Success Message",
          "Inspection Submitted Successfully"
        );
        //this.successDetails = 'Inspection Submitted Successfully';
      }
      this.router.navigate([
        InspectionConstantsService.RoutingURLConstant.InspectionOverviewURL,
      ]);
    } else {
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something went wrong."
      );
    }
    this.baseService.showRootLoader = false;
  }
  downloadPDF() {
    this.notificationsService.toastNotify(
      "info",
      "Information Message",
      "Download is in Progress!"
    );
    const apiRequest = {
      Model: {
        ProcessName:
          ObservationConstantsService.ObservationCardModuleConst.Inspection,
        SourceId: this.inspectionrefId
      }
    };
    this.observationService.downloadPDF(
      apiRequest,
      this.callbackMethodForDownloadPDF.bind(this)
    );
  }

  callbackMethodForDownloadPDF(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "pdf_inspection" + this.inspectionrefId + ".pdf"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);

    }
  }
  resetValue() {
    this.router.navigate([
      InspectionConstantsService.RoutingURLConstant.InspectionOverviewURL,
    ]);
    this.alertType = "";
    this.successDetails = "";
  }
  resetForm() {
    this.inspectionRequest = new InspectionRequest();
    this.selectedContractor = new User();
    this.selectedInspector = new User();
    this.selectedInspectors = [];
    this.displaySelectedInspectorsNames=[];
  }
  validateAddAction(): boolean {
    let isFormValid = true;
    // Action error messages
    this.actionList.forEach((action) => {
      if (action.Action.trim() === "") {
        action.ShowActionErrorMessage = true;
        isFormValid = false;
      }
      if (action.ActionOwner.UserId === 0) {
        action.ShowActionOwnerErrorMessage = true;
        isFormValid = false;
      }
      if (action.selectedActionParty.UserId === 0) {
        action.ShowActionPartyErrorMessage = true;
        isFormValid = false;
      }
      if (action.Priority === 0) {
        action.ShowPriorityErrorMessage = true;
        isFormValid = false;
      }
      if (!action.TargetDate) {
        action.ShowTargetErrorMessage = true;
        isFormValid = false;
      }
    });
    return isFormValid;
  }
  // method to check the validation
  checkValidation() {
    this.baseService.showRootLoader = true;
    this.validate = true;

    this.unitError = true;
    if (this.selectedUnit != undefined){
    if (this.selectedUnit.UnitId) {
      this.unitError = false;
      this.validate = true;
    }}   

    if (this.selectedContractor.UserId === 0) {
      this.isContractorNameErrorMsg = true;
      this.validate = false;
    }
    if (!this.inspectionRequest.LocationId) {
      this.isLocationErrorMsg = true;
      this.validate = false;
    }
    if (!this.inspectionRequest.InspectionDate) {
      this.isInspectorNameErrorMsg = true;
      this.validate = false;
    }
    if (!this.inspectionRequest.InspectionDescription) {
      this.isInspectionDescriptionErrorMsg = true;
      this.validate = false;
    }
    if (!this.inspectionRequest.CheckListId) {
      this.isInspectionNameErrorMsg = true;
      this.validate = false;
    }
    if(!this.selectedInspectors || !this.selectedInspectors.length || this.selectedInspectors.length==0)
    {
      this.isInspectorIdsMsg=true;
      this.validate = false;
    }
    if (this.actionList[0].Action) {
      if (!this.validateAddAction()) {
        this.validate = false;
      }
    }
    if (!this.isEmployeeUnit && this.isContractErrorMsg) 
    {
      this.validate = false;
    }
    
    if (this.validate === true) {
      this.submitInspectionDetails();
    } else {
      this.baseService.showRootLoader = false;
    }
  }

  savePDF() {
    const apiRequest = {
      Model: {
        ProcessName: "Inspection",
        SourceId: this.inspectionId,
        UserId: this.loggedInUserJSON.UserId,
      },
    };
    this.masterscreenService.savePDF(
      apiRequest,
      this.callbackMethodForSavePDF.bind(this)
    );
  }
  callbackMethodForSavePDF(response) { }
  displayImage($event, actionType, index) {
    if (actionType === "inspectionDocument") {
      this.inspectionDocument = $event.type === "mouseenter" ? true : false;
      if (this.inspectionDocument) {
        this.selectedIndex = index;
      }
    } else if (actionType === "uploadedDocument") {
      this.uploadedDocument = $event.type === "mouseenter" ? true : false;
      if (this.uploadedDocument) {
        this.selectedIndex = index;
      }
    }
  }
  showActions(actionId, processId) {
    this.router.navigate([
      "/actiontracker/all-action-details",
      actionId,
      { processId: processId },
    ]);
  }
  addAction() {
    this.actionList.push(new AssignActionForSourcePost());
  }
  removeActionFromActionList(index) {
    if (this.actionList.length > 1) {
      this.actionList.splice(index, 1);
    }
  }
  selectActionParty(event, index) {
    if (!event.UserId) {
      this.actionList[index].selectedActionParty.UserId = 0;
      this.actionList[index].selectedActionParty.FullName = "";
    } else {
      this.actionList[index].ShowActionPartyErrorMessage = false;
    }
  }
  // To get id of selected action verifier
  selectActionVerifier(event, index) {
    if (!event.UserId) {
      this.actionList[index].selectedActionVerifier.UserId = 0;
      this.actionList[index].selectedActionVerifier.FullName = "";
    } else {
      this.actionList[index].ShowActionVerifierErrorMessage = false;
    }
  }
  // To get id of selected action owner
  selectActionOwner(event, index: number) {
    if (event.UserId) {
      this.actionList[index].selectedActionParty = new User();
      // this.actionList[index].selectedActionParty = {
      //   UserId: event.UserId,
      //   FullName: event.FullName,
      //   Email: event.Email,
      //   FirstName: event.FirstName,
      //   LastName: event.LastName,
      //   UserTypeId: event.UserTypeId,
      //   UserTypes: event.UserTypes,
      //   ContactNumber: event.ContactNumber,
      //   Designation: event.Designation,
      //   DepartmentName: event.DepartmentName,
      //   UserTypeName: event.userTypeName,
      //   ContractNumber: event.ContractNumber,
      // };
      this.actionList[index].ShowActionOwnerErrorMessage = false;
      this.actionList[index].ShowActionPartyErrorMessage = false;
    } else {
      this.actionList[index].ActionOwner.UserId = 0;
      this.actionList[index].ActionOwner.FullName = "";
    }
  }
  updateAction() {
    let updateactionList = [];
    if (this.inspectionId > 0) {
      this.inspectionActions.SourceId = this.inspectionId;
    } else {
      this.inspectionActions.SourceId = this.inspectionrefId;
    }
    let hasEmptyActions: boolean = true;
    while (hasEmptyActions) {
      for (var i = 0; i < this.actionList.length; i++) {
        if (this.actionList[i].Action === "") {
          this.actionList.splice(i, 1);
          break;
        } else {
          this.actionList[i].UnitId = parseInt(this.selectedUnit.UnitId);
        }
      }
      hasEmptyActions = false;
    }
    for (var i = 0; i < this.actionList.length; i++) {
      if (
        this.actionList[i].Status !== "Deleted" &&
        this.actionList[i].Status !== "Cancelled" &&
        this.actionList[i].Status !== "Closed" &&
        this.actionList[i].Action !== ""
      ) {
        updateactionList.push(this.actionList[i]);
      }
    }
    if (updateactionList.length >= 1) {
      this.inspectionActions.ActionDetails = updateactionList;
    } else {
      this.inspectionActions.ActionDetails = this.actionList;
    }
    this.inspectionActions.RaisedBy = this.loggedInUserJSON.UserId;
    if (
      this.inspectionActions.ActionDetails !== null &&
      this.inspectionActions.ActionDetails.length > 0
    ) {
      this.inspectionActions.ProcessName = "Inspection";
      const apiRequest = {
        Model: this.inspectionActions,
      };
      this.observationService.updateActionAssignedByHseAdvisor(
        apiRequest,
        this.callbackFromUpdateActionHseAdvisor.bind(this)
      );
    }
  }
  callbackFromUpdateActionHseAdvisor(response) { }
  onPreviousClick() {
    this.inspectionIndex = -1;
    this.isNext = true;
    this.disableInspection = false;
    this.inspectionIds = this.inspectionService.getAllInspectionIds();
    this.inspectionIds.forEach((element, index) => {
      if (element.InspectionId === this.inspectionId && index - 1 != null) {
        this.inspectionIndex = index - 1;
        if (this.inspectionIndex <= 0) {
          this.isPrevious = false;
        } else {
          this.isPrevious = true;
        }
        return;
      }
    });
    if (this.inspectionIndex > -1) {
      this.inspectionId = this.inspectionIds[this.inspectionIndex].InspectionId;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          InspectionRequestId: this.inspectionId,
        },
      };
      this.inspectionService.getInspectionDataByInspectionRequestId(
        apiRequest,
        this.callbackMethodForgetInspectionRequest.bind(this)
      );
      this.router.navigate(["inspection/add-inspection/" + this.inspectionId]);
    }
  }

  onNextClick() {
    this.isPrevious = true;
    this.inspectionIndex = -1;
    this.disableInspection = false;
    this.inspectionIds = this.inspectionService.getAllInspectionIds();
    if(this.inspectionIds!=null)
    {
    this.inspectionIds.forEach((element, index) => {
      if (element.InspectionId === this.inspectionId && index + 1 != null) {
        this.inspectionIndex = index + 1;
        if (this.inspectionIndex + 1 == this.inspectionIds.length) {
          this.isNext = false;
        } else {
          this.isNext = true;
        }
        return;
      }
    });
  }
    if (this.inspectionIndex > -1) {
      this.inspectionId = this.inspectionIds[this.inspectionIndex].InspectionId;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          InspectionRequestId: this.inspectionId,
        },
      };
      this.inspectionService.getInspectionDataByInspectionRequestId(
        apiRequest,
        this.callbackMethodForgetInspectionRequest.bind(this)
      );
      this.router.navigate(["inspection/add-inspection/" + this.inspectionId]);
    }
  }



  getUsersByUsageType(event) {
    this.searchTexts.FilterTexts = event.query;
    const apiRequest = {
      Model: {
        ModuleId: ConstantsService.PermissionMatrixModules.Inspection,
        UnitId: this.selectedUnit.UnitId,
      },
    };
    this.commonService.getUsersByUsageType(
      apiRequest,
      this.callbackMethodForGetUsersByUsageType.bind(this)
    );
  } 

  callbackMethodForGetUsersByUsageType(response) {
    this.userResults = [];
    if (response.Success) {
      const filtered: any[] = [];
      for (let i = 0; i < response.Result.length; i++) {
        this.user = response.Result[i];
        if (
          this.user.FullName.toLowerCase().indexOf(
            this.searchTexts.FilterTexts.toLowerCase()
          ) === 0
        ) {
          filtered.push(this.user);
        }
      }
      this.userResults = filtered;
    }
  }
  getPermissions(unitId) {
    let userPermissionParams: UserPermissionParameters = new UserPermissionParameters();
    userPermissionParams.UserId = this.loggedInUserJSON.UserId;
    userPermissionParams.ModuleId =
      ConstantsService.PermissionMatrixModules.Inspection;
    userPermissionParams.UnitId = unitId;
    const apiRequest = {
      Model: userPermissionParams,
    };
    this.commonService.getPermissionDetailsForUser(
      apiRequest,
      this.callbackMethodForUserPermissions.bind(this)
    );
  }
  callbackMethodForUserPermissions(response) {
    this.permissions = new InspectionPermission();
    this.permissions = response.Result.InspectionPermission;
    if (this.incidentLoaded) {
      this.permissions.INSP_Own =
        this.selectedInspectors.find((element) => {
          if (element === this.loggedInUserJSON.UserId) {
            return true;
          }
        })
          ? true
          : false;
      if (
        !this.permissions.INSP_Admin &&
        !this.permissions.INSP_Admin_Unit &&
        !this.permissions.INSP_Own
      ) {
        this.disableInspection = true;
      }
    }
    if(!this.permissions.INSP_Add && !this.permissions.INSP_Add_Unit && !this.permissions.INSP_Admin && !this.permissions.INSP_Admin_Unit){
      this.isUpdateAllowed = false;
      }
      else{
        this.isUpdateAllowed = true;
      }
  }
  backToOverview() {
    this.router.navigateByUrl("/inspection/inspections-overview");
  }
  getRemarks(remarks, type, index) {
    switch (type) {
      case "Description":
        this.inspectionRequest.InspectionDescription = remarks;
        break;
      case "Remarks":
        this.inspectionRequest.Remarks = remarks;
        break;
      case "Action":
        this.actionList[index].Action = remarks;
        break;
      case "CheckListRemark":
        this.checklistPoints[index].RemarkText = remarks.RemarkText;
        this.checklistPoints[index].Files = remarks.RemarkFiles;
        break;
      case "DeletionReason":
        this.deletionReason = remarks;
        break;
      case "CancellationReason":
        this.cancellationReason = remarks;
        break;
      default:
        break;
    }
  }
  setLocation(location) {
    this.inspectionRequest.ExactLocation = location;
  }
  categoryCheckedEmittedValue(value) {
    this.categoryData = value;
  }
  submitSpecificationData() {
    this.specificationDetailsData.RuleId = this.categoryData;
    this.specificationDetailsData.SourceId = this.inspectionId;
    this.specificationDetailsData.ModuleId = this.moduleId;

    const apiRequest = {
      Model: this.specificationDetailsData,
    };
    this.observationService.submitSpecificationData(
      apiRequest,
      this.callbackMethodForSubmitSpecificationData.bind(this)
    );
  }

  callbackMethodForSubmitSpecificationData(response) {
    if (response.Success) {
    }
  }
  getOutput(event) {
    if (event) {
     // this.ngOnInit();
     this.router.navigate([
      InspectionConstantsService.RoutingURLConstant.InspectionOverviewURL,
    ]);
    }
  }
  cancelAssigned(actionId, index) {
    this.cancelRecord = true;
    this.cancelActionId = actionId;
  }                

  cancelAction(cancelActionId) {
    if (this.cancelActionId > 1 && this.cancellationReason != "" && this.cancellationReason != undefined
      && this.cancellationReason != null) {
      this.cancelRecord = true;  
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          ActionId: this.cancelActionId,
          CancellationReason: this.cancellationReason,
          UpdatedBy: this.loggedInUserJSON.UserId,
          StatusId: 0,
        },
      };
      this.observationService.cancelactiondetails(
        apiRequest,
        this.callbackMethodForCancelActionDetails.bind(this)
      );
    }
    else
    if(this.cancellationReason ==='')
    {
      this.showCancellationmsg = true;
    }
  }
  callbackMethodForCancelActionDetails(response) {
    this.baseService.showRootLoader = false;
    this.cancelRecord = false;
    this.cancellationReason = "";
    this.ngOnInit();
  }
  onCancel() {
    this.cancelRecord = false;
    this.cancellationReason = "";
  }
  deleteAssigned(actionId, index) {
    if (actionId === 0) {
      this.actionList.splice(index, 1);
    } else {
      this.deleteRecord = true;
      this.deleteActionId = actionId;
    }
  }
  deleteAction(deleteActionId) {
    if (this.deleteActionId > 1 && this.deletionReason != "" && this.deletionReason != undefined
      && this.deletionReason != null) {
      this.deleteRecord = true;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          ActionId: this.deleteActionId,
          DeletionReason: this.deletionReason,
          UpdatedBy: this.loggedInUserJSON.UserId,
          StatusId: 0,
        },
      };
      this.observationService.deleteactiondetails(
        apiRequest,
        this.callbackMethodForDeleteActionDetails.bind(this)
      );
    }
    else
    if(this.deletionReason ===''){
      this.showDeletionmsg = true;
    }
  }
  callbackMethodForDeleteActionDetails(response) {
    this.baseService.showRootLoader = false;
    this.deleteRecord = false;
    this.deletionReason = "";
    this.ngOnInit();
  }
  isNew: boolean = false;
  onCancelClick() {
    this.deleteRecord = false;
    this.deletionReason = "";
  }
  getCheckListDetails(checkListId) {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        CheckListId: checkListId,
      },
    };
    this.masterscreenService.getCheckListDetails(
      apiRequest,
      this.callbackMethodForGetCheckListDetails.bind(this)
    );
  }
  callbackMethodForGetCheckListDetails(response) {
    if (response && response.Success) {
      if (response.Result && response.Result.CheckListItems.length > 0) {
        this.checklistPoints = response.Result.CheckListItems;
        this.checklistPoints.forEach((element) => {
          element.Value = 3;
        });
      }
      this.instructionDocuments = response.Result.CheckListFiles;
      this.inspectionRequest.InspectionInstruction = response.Result.CheckListFiles;
    }
    this.baseService.showRootLoader = false;
  }

  //BOC Pritesh
  saveAsDraft() {
    this.baseService.showRootLoader = true;
    this.validate = true;
    if (this.selectedContractor.UserId === 0) {
      this.isContractorNameErrorMsg = true;
      this.validate = false;
    }
    if (!this.inspectionRequest.LocationId) {
      this.isLocationErrorMsg = true;
      this.validate = false;
    }
    if (!this.inspectionRequest.InspectionDate) {
      this.isInspectorNameErrorMsg = true;
      this.validate = false;
    }
    if (!this.inspectionRequest.InspectionDescription) {
      this.isInspectionDescriptionErrorMsg = true;
      this.validate = false;
    }
    if (!this.inspectionRequest.CheckListId) {
      this.isInspectionNameErrorMsg = true;
      this.validate = false;
    }
    
    if(!this.selectedInspectors || !this.selectedInspectors.length || this.selectedInspectors.length==0)
    {
      this.isInspectorIdsMsg=true;
      this.validate = false;
    }


    if (this.actionList[0].Action) {
      if (!this.validateAddAction()) {
        this.validate = false;
      }
    }
    if (this.validate === true) {
      this.DraftInspectionDetails();
    } else {
      this.baseService.showRootLoader = false;
    }
  }
  DraftInspectionDetails()
  {
    this.baseService.showRootLoader = true;
    this.inspectionRequest.ContractorId = this.selectedContractor.UserId;
    this.inspectionRequest.ContractId  = this.isEmployeeUnit?0: this.selectedContractId;
    if (this.inspectionId === 0) {
      this.inspectionRequest.InspectorId = this.loggedInUserJSON.UserId;
    } else {
      this.inspectionRequest.InspectorId = this.selectedInspector.UserId;
      if (this.categoryData && this.categoryData.length > 0) {
        this.submitSpecificationData();
      }
    }
    this.inspectionRequest.InspectorIds = this.selectedInspectors;
    this.inspectionRequest.IsDraft = true;
    this.inspectionRequest.CreatedBy = this.loggedInUserJSON.UserId;
    this.inspectionRequest.ModifiedBy = this.loggedInUserJSON.UserId;
    this.inspectionRequest.CheckListItems = this.checklistPoints;
    this.inspectionRequest.UnitId = this.selectedUnit.UnitId;
    if (this.IsJobStopped === "true") {
      this.inspectionRequest.IsJobStopped = true;
    } else {
      this.inspectionRequest.IsJobStopped = false;
    }
    const apiRequest = {
      Model: this.inspectionRequest
    };
    // Call dummy method to post data
    this.inspectionService.saveInspection(
      apiRequest,
      this.callbackMethodForsaveInspection.bind(this)
    );
  }
  oldActionData;//Pritesh
  trackDetails(OldValue, NewValue, action, isNew) {
   
    const columnNames = Object.getOwnPropertyNames(this.inspectionRequest);
    columnNames.forEach((element) => {
      if (OldValue.length === 0) {
        this.retVal = false;
        // OldValue = null;
      } else {
        this.retVal = this.commonService.isDataEqual(
          OldValue[element],
          NewValue[element]
        );
      }
      if (this.retVal === false) {
      
      if (element === "CheckListItems") {
        const userLoginActivity = new UserLogInActivity();
        userLoginActivity.FieldName = element;
       
          this.inspectionRequest[element].forEach((data) => {
          if(data.Value === 1){this.CheckListValue = "Yes"}
          else if(data.Value === 2){this.CheckListValue = "No"}
          else {this.CheckListValue = "NA"}
          userLoginActivity.NewValue += data.CheckListPoint + " - "+ this.CheckListValue +",";
            
          });
          if (this.updateinspectionData) {
            this.updateinspectionData[element].forEach((data) => {
              if(data.Value === 1){this.CheckListValue = "Yes"}
              else if(data.Value === 2){this.CheckListValue = "No"}
              else {this.CheckListValue = "NA"}
                userLoginActivity.OldValue += data.CheckListPoint + " - "+ this.CheckListValue +",";
             
            });
          } else {
            userLoginActivity.OldValue = null;
          }
        
        if(userLoginActivity.OldValue != userLoginActivity.NewValue)
        {
        this.userActivityList.push(userLoginActivity);
        }
      }
      
      if (element.trim() === "UnitId") {
     
         const userLoginActivity = new UserLogInActivity();
         userLoginActivity.FieldName = element;
         userLoginActivity.OldValue = isNew ? null : OldValue[element];
         userLoginActivity.NewValue = NewValue[element];
         this.userActivityList.push(userLoginActivity);
       
     }
     else if (element === "ContractId") {
 
      const userLoginActivity = new UserLogInActivity();
      userLoginActivity.FieldName = "Contract Number";
      userLoginActivity.OldValue = OldValue[element];
      userLoginActivity.NewValue = NewValue[element];
      this.userActivityList.push(userLoginActivity);
    
    }
    else if (element.trim() === "IsJobStopped") {
    
       const userLoginActivity = new UserLogInActivity();
       userLoginActivity.FieldName = element;
       userLoginActivity.OldValue = isNew ? null : OldValue[element];
       userLoginActivity.NewValue = NewValue[element];
       this.userActivityList.push(userLoginActivity);
    
   }
   else if (element.trim() === "Remarks") {
  
     const userLoginActivity = new UserLogInActivity();
     userLoginActivity.FieldName = element;
     userLoginActivity.OldValue = isNew ? null : OldValue[element];
     userLoginActivity.NewValue = NewValue[element];
     this.userActivityList.push(userLoginActivity);
  
 }
     else if (element === "InspectionName") {
    
       const userLoginActivity = new UserLogInActivity();
       userLoginActivity.FieldName = element;
       userLoginActivity.OldValue = isNew ? null : OldValue[element];
       userLoginActivity.NewValue = NewValue[element];
       this.userActivityList.push(userLoginActivity);
    
   }
   else if (element === "InspectionDescription") {
  
     const userLoginActivity = new UserLogInActivity();
     userLoginActivity.FieldName = element;
     userLoginActivity.OldValue = isNew ? null : OldValue[element];
     userLoginActivity.NewValue = NewValue[element];
     this.userActivityList.push(userLoginActivity);
   
 }
 else if (element.trim() === "LocationName") {

   const userLoginActivity = new UserLogInActivity();
   userLoginActivity.FieldName = element;
   userLoginActivity.OldValue = isNew ? null : OldValue[element];
   userLoginActivity.NewValue = NewValue[element];
   this.userActivityList.push(userLoginActivity);
 
}
else if (element.trim() === "ExactLocation") {

   const userLoginActivity = new UserLogInActivity();
   userLoginActivity.FieldName = element;
   userLoginActivity.OldValue = isNew ? null : OldValue[element];
   userLoginActivity.NewValue = NewValue[element];
   this.userActivityList.push(userLoginActivity);
 
}
else if (element.trim() === "InspectionDate") {

   const userLoginActivity = new UserLogInActivity();
   userLoginActivity.FieldName = element;
   userLoginActivity.OldValue = isNew ? null : OldValue[element];
   userLoginActivity.NewValue = NewValue[element];
   this.userActivityList.push(userLoginActivity);
 
}

else if (element.trim() === "Contractor") {
  this.retVal = this.commonService.isDataEqual(
   OldValue.Contractor.UserId,
   NewValue.ContractorId
 );
 if (this.retVal === false) {
   const userLoginActivity = new UserLogInActivity();
   userLoginActivity.FieldName = "Contractor Name";
   userLoginActivity.OldValue = isNew ? null : OldValue.Contractor.UserId;
   userLoginActivity.NewValue = NewValue.ContractorId;
   this.userActivityList.push(userLoginActivity);
 }
}

   
      else if (element === "LocationId") {
        const userLoginActivity = new UserLogInActivity();
        userLoginActivity.FieldName = element;
        this.locations.forEach((location) => {
          if (location.value === this.inspectionRequest[element]) {
            userLoginActivity.NewValue = location.label;
          }
          if (this.updateinspectionData) {
            if (location.value === this.updateinspectionData[element]) {
              userLoginActivity.OldValue = location.label;
            }
          } else {
            userLoginActivity.OldValue = null;
          }
        });
        this.userActivityList.push(userLoginActivity);
      } 
      else if (
        element === "TimeZone" ||
        element === "ObservationRaiseUser" ||
        element === "ObservationTypeValue" ||
        element === "ObservationDate"
      ) {
       } 
       else if (element === "CheckListFiles") {
        const userLoginActivity = new UserLogInActivity();
        userLoginActivity.FieldName = element;
        if (this.updateinspectionData) {
          for (var i = 0; i < this.updateinspectionData[element].length; i++) {
            const url = this.updateinspectionData.CheckListFiles[i].FilePath;
            userLoginActivity.OldValue += url + ",";
          }
        } else {
          userLoginActivity.OldValue = null;
        }
        for (var i = 0; i < this.inspectionRequest[element].length; i++) {
          let url1 = this.inspectionRequest.CheckListFiles[i].FilePath;
          
          userLoginActivity.NewValue += url1 + ",";
        }
        if(userLoginActivity.OldValue !== userLoginActivity.NewValue)
        {
        this.userActivityList.push(userLoginActivity);
        }
      } 
      
      // else if (element === "InspectionInstruction") {
      //   const userLoginActivity = new UserLogInActivity();
      //   userLoginActivity.FieldName = element;
      //   if (this.updateinspectionData) {
      //     for (var i = 0; i < this.updateinspectionData[element].length; i++) {
      //       const url = this.updateinspectionData.InspectionInstruction[i].FilePath;
      //       userLoginActivity.OldValue += url + ",";
      //     }
      //   } else {
      //     userLoginActivity.OldValue = null;
      //   }
      //   for (var i = 0; i < this.inspectionRequest[element].length; i++) {
      //     let url1 = this.inspectionRequest.InspectionInstruction[i].FilePath;
          
      //     userLoginActivity.NewValue += url1 + ",";
      //   }
      //   if(userLoginActivity.OldValue !== userLoginActivity.NewValue)
      //   {
      //   this.userActivityList.push(userLoginActivity);
      //   }
      // } 
      
      else if (element === "InspectionFiles") {
        const userLoginActivity = new UserLogInActivity();
        userLoginActivity.FieldName = element;
        if (this.updateinspectionData) {
          for (var i = 0; i < this.updateinspectionData[element].length; i++) {
            const url = this.updateinspectionData.InspectionFiles[i].Name;
            userLoginActivity.OldValue += url + ",";
          }
        } else {
          userLoginActivity.OldValue = null;
        }
        for (var i = 0; i < this.inspectionRequest[element].length; i++) {
          let url1 = this.inspectionRequest.InspectionFiles[i].Name;
          
          userLoginActivity.NewValue += url1 + ",";
        }
        if(userLoginActivity.OldValue !== userLoginActivity.NewValue)
        {
        this.userActivityList.push(userLoginActivity);
        }
      } 
      
     
      else {
       
      }
    }
    });

    //BOC Pritesh
    this.oldActionData = JSON.parse(
      this.inspectionService.getoldActionData()
    );
    
  
    for(var i=0;i<this.actionList.length;i++)
    {
      
       //Action Description Comparison
       const userLoginActivity = new UserLogInActivity();
       userLoginActivity.FieldName = "Action Description - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId) ;
       userLoginActivity.OldValue = this.oldActionData[i] != undefined ? this.oldActionData[i].Action : ""; 
       userLoginActivity.NewValue = this.actionList[i] != undefined ? this.actionList[i].Action : "";
       if(userLoginActivity.OldValue != userLoginActivity.NewValue)
       {
         this.userActivityList.push(userLoginActivity);
       }
               
       //Action Owner Comparison
       const userLoginActivity1 = new UserLogInActivity();
       userLoginActivity1.FieldName = "Action Owner - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId );
       userLoginActivity1.OldValue = this.oldActionData[i] != undefined ? this.oldActionData[i].ActionOwner.FullName : ""; 
       userLoginActivity1.NewValue = this.actionList[i] != undefined ? this.actionList[i].ActionOwner.FullName : "";
       if(userLoginActivity1.OldValue != userLoginActivity1.NewValue)
       {
         this.userActivityList.push(userLoginActivity1);
       }

        //Action Party Comparison
        const userLoginActivity2 = new UserLogInActivity();
        userLoginActivity2.FieldName = "Action Party - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId) ;
        userLoginActivity2.OldValue = this.oldActionData[i] != undefined ? this.oldActionData[i].selectedActionParty.FullName : ""; 
        userLoginActivity2.NewValue = this.actionList[i] != undefined ? this.actionList[i].selectedActionParty.FullName : "";
        if(userLoginActivity2.OldValue != userLoginActivity2.NewValue)
        {
          this.userActivityList.push(userLoginActivity2);
        }

         //Action Verifier Comparison
         const userLoginActivity3 = new UserLogInActivity();
         userLoginActivity3.FieldName = "Action Verifier - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId) ;
         userLoginActivity3.OldValue = this.oldActionData[i] != undefined ? this.oldActionData[i].selectedActionVerifier.FullName : ""; 
         userLoginActivity3.NewValue = this.actionList[i] != undefined ? this.actionList[i].selectedActionVerifier.FullName : "";
         if(userLoginActivity3.OldValue != userLoginActivity3.NewValue)
         {
           this.userActivityList.push(userLoginActivity3);
         }

          //Action Priority Comparison
          const userLoginActivity4 = new UserLogInActivity();
          userLoginActivity4.FieldName = "Action Priority - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId) ;
          userLoginActivity4.OldValue = this.oldActionData[i] != undefined ? this.oldActionData[i].Priority : ""; 
          if(userLoginActivity4.OldValue.toString() === "1")
          {
            userLoginActivity4.OldValue = "Low";
          }
          else if(userLoginActivity4.OldValue.toString() === "2")
          {
            userLoginActivity4.OldValue = "Medium";
          }
          else if(userLoginActivity4.OldValue.toString() === "3")
          {
            userLoginActivity4.OldValue = "High";
          }
          userLoginActivity4.NewValue = this.actionList[i] != undefined ?(this.actionList[i].Action !== "" ? this.actionList[i].Priority : "") : "";
          if(userLoginActivity4.NewValue.toString() === "1")
          {
            userLoginActivity4.NewValue = "Low";
          }
          else if(userLoginActivity4.NewValue.toString() === "2")
          {
            userLoginActivity4.NewValue = "Medium";
          }
          else if(userLoginActivity4.NewValue.toString() === "3")
          {
            userLoginActivity4.NewValue = "High";
          }
          if(userLoginActivity4.OldValue != userLoginActivity4.NewValue)
          {
            this.userActivityList.push(userLoginActivity4);
          }
          
        //Action Target Date Comparison
         const userLoginActivity5 = new UserLogInActivity();
         userLoginActivity5.FieldName = "Action Target Date - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId) ;
         userLoginActivity5.OldValue = this.oldActionData[i] != undefined ? this.oldActionData[i].TargetDate : ""; 
         if(userLoginActivity5.OldValue !== "")
         {
          userLoginActivity5.OldValue = moment(
            moment.utc(userLoginActivity5.OldValue).local()
          ).toDate();
         }
         userLoginActivity5.NewValue = this.actionList[i] != undefined ?(this.actionList[i].Action !== "" ? this.actionList[i].TargetDate : "") : "";
         if(userLoginActivity5.NewValue !== "")
         {
          userLoginActivity5.NewValue = moment(
            moment.utc(userLoginActivity5.NewValue).local()
          ).toDate();
         }
         if(userLoginActivity5.OldValue != userLoginActivity5.NewValue)
         {
           this.userActivityList.push(userLoginActivity5);
         }

          //Action Files Comparison
          const userLoginActivity6 = new UserLogInActivity();
          userLoginActivity6.FieldName = "Action Files - "  + (this.oldActionData[i] != undefined ? this.oldActionData[i].ActionId : this.actionList[i].ActionId) ;
          if (this.oldActionData[i] != undefined && this.oldActionData[i].Files.length > 0) {
            for (var j = 0; j < this.oldActionData[i].Files.length; j++) {
              const url = this.oldActionData[i].Files[j]
                .Name;
              userLoginActivity6.OldValue += url + ",";
            }
          } else {
            userLoginActivity6.OldValue = "";
          }
          if (this.actionList[i] != undefined && this.actionList[i].Files.length > 0) {
            for (var j = 0; j < this.actionList[i].Files.length; j++) {
              const url = this.actionList[i].Files[j]
                .Name;
              userLoginActivity6.NewValue += url + ",";
            }
          } else {
            userLoginActivity6.NewValue = "";
          }
          if(userLoginActivity6.OldValue != userLoginActivity6.NewValue)
          {
            this.userActivityList.push(userLoginActivity6);
          }
    }
   
    //EOC Pritesh

    if (this.userActivityList.length > 0) {
      this.commonService.saveUserActivityDetails(
        this.isNew ? this.inspectionrefId : this.inspectionId,
        new Date(),
        "Inspection",
        this.loggedInUserJSON.UserId,
        this.userActivityList
      );
    }
  }

  //EOC Pritesh
  
   //BOC Pritesh
   ReportshowDialog() {
    
    this.ReportUserId = this.loggedInUserJSON.UserId;
    this.ReportModule = "Inspection";
    this.ReportRecordId = this.inspectionId;
    this.ReportProcessId = 0;
    this.dialogHeight = (window.innerHeight - 50).toString() + "px";
    this.dialogWidth = window.innerWidth.toString() + "px";
    this.ReportclosePopup = true;
  }
  ReportclosePopUp() {
    this.ReportclosePopup = false;
  }
  //EOC Pritesh

  //Inpectors
  setInpectorsUsersData() {
    this.searchTexts.UserTypeId = 0;
    this.searchTexts.FilterTexts = "";
    this.searchTexts.CompanyId = 0;
    this.searchTexts.UnitId = -1;
    const apiRequest = {
      Model: this.searchTexts
    };
    this.commonService.getSearchResultsForUsers(apiRequest, this.callbackMethodForGetSearchResultsForallUsers.bind(this));
  }
  callbackMethodForGetSearchResultsForallUsers(response) {
    if (response.Success) {      
      this.allInspectorsResults = response.Result;
      this.allInspectorsData = [];
      this.allInspectorsResults.forEach(s =>
        this.allInspectorsData.push({
          label: s.Designation ? `${s.FullName} (${s.Designation})` : s.FullName,
          value: s.UserId
        })
      );   
    
      this.changeValueofInspector()
    }        
     
  }

  changeValueofInspector() {
    this.displaySelectedInspectorsNames=[];
      if(this.selectedInspectors.length && this.selectedInspectors.length>0)
      {
        var i=1;
        this.selectedInspectors.forEach((element)=>{
          var item=this.allInspectorsData.find(s => s.value == element);
          if(item){
              this.displaySelectedInspectorsNames.push({Name:item.label,Number:i})
              i++;
          }
        });
      }
  }


}
export class InspectionRequest {
  InspectionRequestId: number = 0;
  InspectionName: string = "";
  InspectionDate: Date = new Date();
  InspectionDescription: string = "";
  InspectorId: number = 0;
  IsJobStopped: Boolean;
  Remarks: string = "";
  CreatedBy: number = 0;
  ModifiedBy: number = 0;
  IsYes: boolean;
  IsNo: boolean;
  LocationId: number;
  ExactLocation: string;
  CheckListId: number = 0;
  Selected: string;
  InspectionFiles: any[] = [];
  InspectionInstruction: any[] = [];
  ContractorId: number;
  CheckListItems: CheckListItem[];
  UnitId: number;
  ActionDetails: AssignActionForSourcePost[];
  Status: string;
  CheckListFiles: any[] = [];
  IsDraft:boolean=false;
  ContractId :number;
  InspectorIds: any[] = [];
}
